import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=aa6d0b8e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=aa6d0b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6d0b8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa6d0b8e')) {
      api.createRecord('aa6d0b8e', component.options)
    } else {
      api.reload('aa6d0b8e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=aa6d0b8e&scoped=true&", function () {
      api.rerender('aa6d0b8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nvsL5eipehQC/JS/comp/DocBox.vue"
export default component.exports